import Box from '@mui/material/Box';
import "@/app/style/globals.scss";

export default function Loading() {
  // You can add any UI inside Loading, including a Skeleton.
  return <Box className="Loadingcontainer" sx={{ display: 'flex', justifyContent: "center" }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="35" stroke="#444" speed="1"
        data-testid="rotating-lines-svg" aria-label="rotating-lines-loading" aria-busy="true" role="progressbar"
        className="LoadingSvg">
        <polyline points="24,12 24,4" width="4" transform="rotate(0, 24, 24)" className="loadingDash"></polyline>
        <polyline points="24,12 24,4" width="4" transform="rotate(30, 24, 24)" className="loadingDash"></polyline>
        <polyline points="24,12 24,4" width="4" transform="rotate(60, 24, 24)" className="loadingDash"></polyline>
        <polyline points="24,12 24,4" width="4" transform="rotate(90, 24, 24)" className="loadingDash"></polyline>
        <polyline points="24,12 24,4" width="4" transform="rotate(120, 24, 24)" className="loadingDash"></polyline>
        <polyline points="24,12 24,4" width="4" transform="rotate(150, 24, 24)" className="loadingDash"></polyline>
        <polyline points="24,12 24,4" width="4" transform="rotate(180, 24, 24)" className="loadingDash"></polyline>
        <polyline points="24,12 24,4" width="4" transform="rotate(210, 24, 24)" className="loadingDash"></polyline>
        <polyline points="24,12 24,4" width="4" transform="rotate(240, 24, 24)" className="loadingDash"></polyline>
        <polyline points="24,12 24,4" width="4" transform="rotate(270, 24, 24)" className="loadingDash"></polyline>
        <polyline points="24,12 24,4" width="4" transform="rotate(300, 24, 24)" className="loadingDash"></polyline>
        <polyline points="24,12 24,4" width="4" transform="rotate(330, 24, 24)" className="loadingDash"></polyline>
      </svg>
  </Box>
}